module.exports = __webpack_public_path__ + "img/teeth-48.631016f0.png";